import { render } from "./AdvisorFYC.vue?vue&type=template&id=3dadb0f0&scoped=true"
import script from "./AdvisorFYC.vue?vue&type=script&lang=js"
export * from "./AdvisorFYC.vue?vue&type=script&lang=js"

import "./AdvisorFYC.vue?vue&type=style&index=0&id=3dadb0f0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dadb0f0"]])

export default __exports__